import { useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { useCancelTask } from '~/tasks-drawer/hooks/useCancelTask';
import { useTasksJobs } from '~/tasks-drawer/hooks/useTasksJobs';
import { useFeatureFlags } from '../useFeatureFlags';
export const retryPdfErrorToastId = (previousJobId)=>"retry-agreement-pdf-error-".concat(previousJobId);
function jobToTask(res, relationshipId) {
    return {
        jobId: res.jobId,
        kind: 'relationshipPdf',
        status: res.status,
        progress: res.progress,
        updatedAt: Date.now(),
        seen: false,
        agreementName: res.agreementName,
        relationshipId
    };
}
export function useDownloadAgreementPdf() {
    const { api } = useStoreActions();
    const { addTask } = useTasksJobs({
        enabled: false
    });
    const { cancelTask } = useCancelTask();
    const { AGREEMENT_PDF_AMENDMENTS_LOG } = useFeatureFlags();
    const { showErrorToast } = useOverlayContext();
    const { t: tasksDrawerTexts } = useLocaleKeys('tasksDrawer');
    return {
        downloadAgreementPdf (relationshipId, lang, overrides) {
            api.pdf.generateRelationshipPdf(relationshipId, lang, !!AGREEMENT_PDF_AMENDMENTS_LOG).then((res)=>{
                var _ref;
                addTask(jobToTask(res, relationshipId), {
                    kind: 'auto',
                    message: (_ref = overrides === null || overrides === void 0 ? void 0 : overrides.generating) !== null && _ref !== void 0 ? _ref : tasksDrawerTexts.generating.startedToast()
                }, {
                    ready: overrides === null || overrides === void 0 ? void 0 : overrides.ready,
                    failed: overrides === null || overrides === void 0 ? void 0 : overrides.failed
                });
            }).catch(()=>{
                showErrorToast(tasksDrawerTexts.relationshipPdf.startFailedToast(), 'download-agreement-pdf-error');
            });
        },
        retryAgreementPdf (relationshipId, param) {
            let { previousJobId, lang } = param;
            cancelTask(previousJobId);
            api.pdf.generateRelationshipPdf(relationshipId, lang, !!AGREEMENT_PDF_AMENDMENTS_LOG).then((res)=>{
                addTask(jobToTask(res, relationshipId), {
                    kind: 'auto',
                    message: tasksDrawerTexts.generating.startedToast()
                });
            }).catch(()=>{
                showErrorToast(tasksDrawerTexts.relationshipPdf.retryFailedToast(), retryPdfErrorToastId(previousJobId));
            });
        }
    };
}
